module.exports = __webpack_public_path__ + "img/video-pic03.ac1af58b.png";